export interface UploadedFile {
  file_id?: string;
  file_name: string;
  status: string;
  url: string;
  hash?: string;
  info?: {
    [pro: string]: any;
  };
}

export enum EUploadStatus {
  completed = "completed",
  uploading = "uploading",
  error = "error",
}

export interface IFile {
  file: File;
  uploadStatus: EUploadStatus;
  uploadInfo?: UploadedFile;
}

export enum ValidateError {
  overFileNumber = 1,
  overFileSize = 2,
  tooSmallImage = 3,
  tooLargeImage = 4,
  extensionError = 5,
  plainTextNotUtf8 = 6,
}

export interface ValidateFileListRes {
  overSizeFiles: File[];
  tooSmallImage?: File[];
  tooLargeImage: File[];
  extensionErrorFiles: File[];
  notUTF8PlainTextFiles: File[];
  emptyFiles: File[];
}

export type IFileListItem = {
  files_info: {
    file_id: string;
    file_name: string;
    file_content_type: string;
  }[];
  folder_id: string;
  folder_name: string;
};

export interface IFileObject {
  file_id: string;
  folder_id: string;
  name: string;
  file_content_type: string;
  children: IFileObject[];
}

export enum EFileSelectErr {
  OverNumber,
  OverSize,
  IllegalFileFormat,
  IllegalFileEncoding,
  Error,
}

export enum ESummaryStatus {
  pending,
  success,
  failure,
}

export enum ETipType {
  all = "all",
  file = "file",
  folder = "folder",
}

export interface ITip {
  channel: ETipType;
  sys_prompt: string;
  tips: string;
}

export interface IRichModalFileSign {
  size: number;
  name: string;
  MD5: string;
  content_type: string;
  type: "file" | "image";
}

export interface IRichModalFileSignRes {
  file_id: string;
  file_md5: string;
  url: string;
  status: string;
  name: string;
}

export interface IRichModalFileCommitInfo {
  file_id: string;
  link?: string;
  url: string;
  status: "running" | "success" | "failed" | "timeout";
}

// 文件状态 running-解析中;success-解析成功;failed-解析失败;timeout-解析超时，默认是180s
export enum ERichModalFileParseStatus {
  running = "running",
  success = "success",
  failed = "failed",
  timeout = "timeout",
  invalid = "invalid",
  empty = "empty",
  limit429 = "limit429",
}

export interface IRichModalFileStatusInfo {
  "file_id": string;
  "is_simple_file": boolean;
  "has_words": boolean;
  "status": ERichModalFileParseStatus;
  "token": number;
  "link"?: string;
}

export interface IRichModalFileDetail {
  "content_type": string;
  "file_id": string;
  "file_name": string;
  "url": string;
}

export interface IRichModalFile {
  file: File;
  uploadInfo?: UploadedFile | null;
  parseInfo?: IRichModalFileStatusInfo | null;
  validateInfo?: {
    type: keyof ValidateFileListRes;
  };
  // token_count?: number;
}

export enum ERichModalFileNormStatus {
  uploading = "uploading",
  netError = "netError",
  error = "error",
  parsing = "parsing",
  longParsing = "longParsing",
  noWords = "noWords",
  formatError = "formatError",
}

export type TRichModalFileStatus =
  | ERichModalFileNormStatus
  | ERichModalFileParseStatus;

export enum EFileType {
  // excel = "excel",
  pdf = "pdf",
  word = "word",
  ppt = "ppt",
  txt = "txt",
  epub = "epub",
  mobi = "mobi",
  md = "markdown",
  other = "other",
}
